import { Route } from "react-router-dom";
import CareManagerLayout from "./CareManagerLayout";
import { lazyPage } from "../shared/lazyPage";

const CareManagerMyCases = lazyPage(() => import("../../pages/CareManagerMyCases"));
const CareManagerCareLogs = lazyPage(() => import("../../pages/CareManagerCareLogs"));
const CareManagerReplacements = lazyPage(() => import("../../pages/CareManagerReplacements"));
const CareManagerSubscription = lazyPage(() => import("../../pages/CareManagerSubscription"));
const CareManagerProfile = lazyPage(() => import("../../pages/CareManagerProfile"));
const CareManagerCarePlan = lazyPage(() => import("../../pages/CareManagerCarePlan"));
const CareManagerAssessments = lazyPage(() => import("../../pages/CareManagerAssessments"));
const CareManagerMarketplace = lazyPage(() => import("../../pages/CareManagerMarketplace"));
const CareManagerExceptions = lazyPage(() => import("../../pages/CareManagerExceptions"));
const NotificationsPage = lazyPage(() => import("../../pages/NotificationsPage"));
const MessengerPage = lazyPage(() => import("../../pages/MessengerPage"));
const CareManagerCaregiverNotes = lazyPage(() => import("../../pages/CareManagerCaregiverNotes"));
const CareManagerOnboardingStatus = lazyPage(() => import("../../pages/CareManagerOnboardingStatus"));
const CareManagerDocumentsPage = lazyPage(() => import("../../pages/CareManagerDocumentsPage"));

export function renderCareManagerRoutes() {
  return (
    <>
      <Route element={<CareManagerLayout />}>
        <Route path="/care-manager" element={<CareManagerMyCases />} />
        <Route path="/care-manager/onboarding" element={<CareManagerOnboardingStatus />} />
        <Route path="/care-manager/documents" element={<CareManagerDocumentsPage />} />
        <Route path="/care-manager/care-plans" element={<CareManagerCarePlan />} />
        <Route path="/care-manager/assessments" element={<CareManagerAssessments />} />
        <Route path="/care-manager/marketplace" element={<CareManagerMarketplace />} />
        <Route path="/care-manager/care-logs" element={<CareManagerCareLogs />} />
        <Route path="/care-manager/exceptions" element={<CareManagerExceptions />} />
        <Route path="/care-manager/replacements" element={<CareManagerReplacements />} />
        <Route path="/care-manager/subscription" element={<CareManagerSubscription />} />
        <Route path="/care-manager/profile" element={<CareManagerProfile />} />
        <Route path="/care-manager/notifications" element={<NotificationsPage role="CARE_MANAGER" />} />
        <Route path="/care-manager/messenger" element={<MessengerPage role="CARE_MANAGER" />} />
        <Route
          path="/care-manager/caregivers/:caregiverId/notes"
          element={<CareManagerCaregiverNotes />}
        />
      </Route>
    </>
  );
}
